export default "__VITE_ASSET__DlN04mZX__"